/**
 * @generated SignedSource<<3f796e7969444ec78c2f1a2d3403b991>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type previewQuery$variables = Record<PropertyKey, never>;
export type previewQuery$data = {
  readonly subscription: {
    readonly maxProducts: {
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"salesChannelsActive">;
};
export type previewQuery = {
  response: previewQuery$data;
  variables: previewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "previewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "salesChannelsActive"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "previewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "status",
            "value": "ACTIVE"
          }
        ],
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannelDetailProperties",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceGlobalID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitiveUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elapsedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modifiedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSwitcherTaskExtraData",
            "kind": "LinkedField",
            "name": "extraData",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "masterSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondarySalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delayMinutes",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSellerMigrating",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16a9fc0111d6a8a8f6396a90ebb65b6a",
    "id": null,
    "metadata": {},
    "name": "previewQuery",
    "operationKind": "query",
    "text": "query previewQuery {\n  subscription {\n    maxProducts {\n      pricingVersion\n      numProducts\n      numPublishedProducts\n      maxProducts\n    }\n    id\n  }\n  ...salesChannelsActive\n}\n\nfragment salesChannelsActive on Query {\n  user {\n    userID\n    email\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n    ecommerceSettings {\n      id\n      ecommerceGlobalID\n      ecommerceName\n      remoteUrl\n      isMarketplace\n      definitiveUrl\n      currencyCode\n    }\n  }\n  productSwitcherTasks {\n    taskID\n    state\n    taskType\n    lastError\n    elapsedTime\n    modifiedOn\n    extraData {\n      taskID\n      masterSalesChannelID\n      secondarySalesChannelID\n      delayMinutes\n    }\n    id\n  }\n  isSellerMigrating\n}\n"
  }
};
})();

(node as any).hash = "a93580c6b190d24a18dd0ab2f979c5fb";

export default node;
